import { ref, computed } from 'vue'
import { useNewsStore } from '@/store/modules/news'

const emojiRegex = /\p{Emoji}/gu

const prepareTitle = (text: string): string => {
  return text ? text.replace(emojiRegex, '').trim() : ''
}

export const useMarketingPosts = () => {
  const newsStore = useNewsStore()
  const loading = ref(true)

  newsStore.GetItems().then(() => {
    loading.value = false
  })

  const rawItems = computed(() => {
    return Object.values(newsStore.items).sort(
      (a: any, b: any) => Number(b.id) - Number(a.id)
    )
  })

  const processedItems = computed(() => {
    return rawItems.value.map((item: any) => ({
      title: prepareTitle(item.attributes.title),
      description: item.attributes.description,
      url: item.attributes.link
    }))
  })

  const show = computed(() => {
    return !loading.value && processedItems.value.length > 0
  })

  return {
    show,
    items: processedItems,
    loading,
    blockTitle: 'News'
  }
}
